import { PackId } from '../utils/offerBus'

export type ObjectionId =
  | 'price'
  | 'prescription'
  | 'battery'
  | 'fit'
  | 'shipping'
  | 'warranty'
  | 'pack'
  | 'crew'
  | 'looking'

export interface ObjectionChoice {
  id: ObjectionId
  label: string
  /** Pack preselected when this answer is chosen. 'business' points at the crew pack section. */
  recommend: PackId | 'business' | null
}

/**
 * What a visitor can tell us is holding them back. Each answer opens one short
 * response low on the page that solves the objection first, then gives a
 * relevant next step. No answer triggers an automatic discount.
 */
export const objectionChoices: ObjectionChoice[] = [
  { id: 'price', label: 'Price / value', recommend: 'trio' },
  { id: 'prescription', label: 'Prescription lenses', recommend: 'single' },
  { id: 'battery', label: 'Battery / runtime', recommend: 'trio' },
  { id: 'fit', label: 'Fit / comfort', recommend: 'single' },
  { id: 'shipping', label: 'Shipping', recommend: 'trio' },
  { id: 'warranty', label: 'Warranty', recommend: 'trio' },
  { id: 'pack', label: 'Which pack is right for me?', recommend: null },
  { id: 'crew', label: 'Buying for a crew / business', recommend: 'crew' },
  { id: 'looking', label: 'Just looking', recommend: null },
]

export const objectionModal = {
  headline: 'Still deciding?',
  subheadline: "What's holding you back?",
  support: "Tell us what you want to know. We'll show you the answer.",
  wantIt: {
    label: 'None of these. I want it.',
    sub: 'Take 5% off and go straight to the packs.',
    badge: '5% off',
  },
}

/** Anchor for the single recovery area. */
export const RECOVERY_ID = 'objection-recovery'
